import React from 'react';
import moment from "moment";
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,age,onDelete,onEdit,onViewGroupBatch,handleIsActiveChange}) => {
    // Same states as the desktop Active column
    const active = data.isGroupBatch ?
        <Chip className="pp-pill" label="Group Batch" style={{ backgroundColor: '#4caf50', color: 'white' }} />
        : (data.isActive || data.reactivate) ?
        <Switch
            checked={data.isActive}
            onChange={handleIsActiveChange}
            color="primary"
            size="small"
            inputProps={{ 'aria-label': 'primary checkbox' }}
        />
        :
        <Chip className="pp-pill" label="Deactivated" style={{ backgroundColor: '#f44336', color: 'white' }} />;

    const rows = [
        { label: 'Active', value: active, inHeader: true, hideLabel: true },
        { label: 'Shed', value: data.shedName },
        { label: 'Breed', value: data.breedName },
        { label: 'Number of Birds', value: data.numberOfBirds },
        ...(age !== undefined ? [{ label: 'Age', value: age || '-' }] : []),
        { label: 'Purchase Date', value: moment(data.purchaseDate).format("DD-MM-YYYY") },
    ];

    // Same as desktop: View for group batches, Edit/Delete only for active batches
    const menuItems = data.isGroupBatch ?
        [{ label: 'View Group Batch', onClick: onViewGroupBatch }]
        : data.isActive ?
        [{ label: 'Edit', onClick: onEdit }, { label: 'Delete', onClick: onDelete }]
        : undefined;

    return (
        <PPMobileCardView
            title={data.name}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
